import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: 'img[fallbackImage]'
})
export class FallbackImageDirective implements AfterViewInit, OnChanges, OnDestroy {

  @Input() fallbackImage!: string;
  @Input() src!: string;

  private errorHandler!: () => void;
  private isFallbackApplied = false;

  constructor(private el: ElementRef<HTMLImageElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.attachErrorHandler();
    this.applySrcSafely(this.src);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src'] && !changes['src'].firstChange) {
      this.isFallbackApplied = false;
      this.applySrcSafely(this.src);
    }
  }

  private attachErrorHandler(): void {
    const element = this.el.nativeElement;

    if (this.errorHandler) {
      element.removeEventListener('error', this.errorHandler);
    }

    this.errorHandler = () => {
      if (!this.isFallbackApplied && this.fallbackImage) {
        this.isFallbackApplied = true;
        this.renderer.setAttribute(element, 'src', this.fallbackImage);
      }
    };

    element.addEventListener('error', this.errorHandler);
  }

  private applySrcSafely(src: string): void {
    if (!src) return;

    const element = this.el.nativeElement;

    // IMPORTANT: Do NOT clear the src (this caused your broken image flash)
    if (element.src !== src) {
      this.renderer.setAttribute(element, 'src', src);
    }
  }

  ngOnDestroy(): void {
    const element = this.el.nativeElement;
    if (this.errorHandler) {
      element.removeEventListener('error', this.errorHandler);
    }
  }
}